export default __webpack_public_path__ + "static/char-04-ccfecb287e32e9494f658fb64d4ac982.webp";